import { useEffect, useState } from 'react';
import { NOTIFICATION_SERVICE_URLS } from '~/Constants/Urls.constants';
import { CombineUniqueObjects } from '~/Helpers/Array.helpers';
import { routeReplacer } from '~/Helpers/String.helper';
import { useProvider, useRequest, useUser } from '~/Hooks';
import { IErrorResponse } from '~/Models/DTO/Error.models';
import { INotificationSettings } from '~/Models/DTO/NotificationSettings.model';

export const useNotificationSettings = () => {
  const { requestWithCallback } = useRequest();
  const { currentProvider } = useProvider();
  const { currentUser } = useUser();
  const [notificationSettings, setNotificationSettings] = useState<INotificationSettings[]>([]);
  const [isLoading, setIsLoading] = useState(false);
  const [hasError, setHasError] = useState<IErrorResponse>({});

  useEffect(() => {
    setIsLoading(true);
    requestWithCallback<INotificationSettings[]>(
      {
        url: routeReplacer(NOTIFICATION_SERVICE_URLS.GET_NOTIFICATION_SETTINGS_BY_USER, {
          id: currentProvider?.uuid || '',
          userUUID: currentUser?.uuid || '',
        }),
        method: 'GET',
      },
      (data) => {
        setIsLoading(false);
        setNotificationSettings(data);
      },
      (error) => {
        setIsLoading(false);
        setHasError(error);
      },
    );
  }, [currentProvider?.uuid]);

  const updateNotificationSettings = (newNotificationSettings: INotificationSettings) => {
    setIsLoading(true);
    requestWithCallback<INotificationSettings>(
      {
        url: routeReplacer(NOTIFICATION_SERVICE_URLS.GET_NOTIFICATION_SETTINGS, {
          id: currentProvider?.uuid || '',
        }),
        method: 'PUT',
        data: newNotificationSettings,
      },
      (data) => {
        setIsLoading(false);
        setNotificationSettings(
          CombineUniqueObjects(notificationSettings, [data], 'applicationUserId'),
        );
      },
      (error) => {
        setIsLoading(false);
        setHasError(error);
      },
    );
  };

  return {
    notificationSettings,
    updateNotificationSettings,
    isLoading,
    hasError,
  };
};
